<script lang="ts">
	export let disabled = false;
	export let text = "";
	export let id = "";

</script>

<button id={id} on:click type="button" disabled={disabled}> {text} </button>

<style lang="scss">
	button {
		font-size: 1.125rem;
		display: block;
		color: #bcbfc3;
		background: none;
		border: none;
		transition: color 0.15s;

		&:not(:disabled):active {
			color: #95a6bd;
		}

		&:hover {
			cursor: pointer;
		}
	}

</style>
